import { render, staticRenderFns } from "./GroupDetail.vue?vue&type=template&id=9b25e450&scoped=true"
import script from "./GroupDetail.vue?vue&type=script&lang=js"
export * from "./GroupDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b25e450",
  null
  
)

export default component.exports